import React from 'react';
import SlickSlider from 'react-slick';
import styled from 'styled-components';
import { rem } from 'polished';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRotateLeft,
  faChevronCircleLeft,
  faChevronCircleRight,
} from '@fortawesome/pro-light-svg-icons';

interface ISliderPaginationButton {
  onClick?: () => void;
  slickRef?: SlickSlider;
  currentSlide: number;
  lastSlide: number;
  direction: 'next' | 'previous';
}

const StyledSliderPaginationButton = styled.button`
  position: absolute;
  z-index: 1099;
  top: calc(100% + 12px);
  width: ${rem(`36px`)};
  height: ${rem(`36px`)};
  color: ${({ theme }) => theme.colors.yellow_2};
  font-size: ${rem(`36px`)};
  line-height: ${rem(`36px`)};
  &[disabled],
  &:hover[disabled] {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.blue_3_45};
  }
  ${({ theme }) => theme.breakpoints.phone`
    top: calc(100% + 12px);
    width: ${rem(`48px`)};
    height: ${rem(`48px`)};
    font-size: ${rem(`48px`)};
    line-height: ${rem(`48px`)};
  `}
  ${({ theme }) => theme.breakpoints.desktop`
    top: calc(100% + 18px);
    width: ${rem(`60px`)};
    height: ${rem(`60px`)};
    font-size: ${rem(`60px`)};
    line-height: ${rem(`60px`)};
    transition: color 300ms ease-in-out;
    &:hover {
      color: ${theme.colors.pink_2};
      transition: color 300ms ease-in-out;
    }
  `}
  &.next {
    right: ${rem(`12px`)};
    ${({ theme }) => theme.breakpoints.desktop`
      right: ${rem(`37px`)};
    `}
  }
  &.previous {
    left: ${rem(`12px`)};
    ${({ theme }) => theme.breakpoints.desktop`
      left: ${rem(`37px`)};
    `}
  }
`;

export const SliderPaginationButton = ({
  direction,
  onClick,
  slickRef,
  currentSlide,
  lastSlide,
}: ISliderPaginationButton) => {
  const isLastSlide = currentSlide === lastSlide;
  const onClickHandler =
    direction === `next` && isLastSlide
      ? () => {
          slickRef.slickGoTo(0);
        }
      : onClick;
  const nextIcon = isLastSlide ? (
    <FontAwesomeIcon icon={faArrowRotateLeft} />
  ) : (
    <FontAwesomeIcon icon={faChevronCircleRight} />
  );
  return (
    <StyledSliderPaginationButton
      aria-label={direction}
      type="button"
      className={direction}
      onClick={onClickHandler}
      disabled={direction === `previous` && currentSlide === 0}
    >
      {direction === `next` && nextIcon}
      {direction === `previous` && (
        <FontAwesomeIcon icon={faChevronCircleLeft} />
      )}
    </StyledSliderPaginationButton>
  );
};
